import { on, select, selectAll, addClass, removeClass } from 'modules/dom'

const ACTIVATE_GRID_CLASS = 'active-view-grid'
const ACTIVATE_LIST_CLASS = 'active-view-list'

export default function (el) {
  const viewGridButton = selectAll('.js-view-grid', el)
  const viewListButton = selectAll('.js-view-list', el)
  const currentURL = window.location.href;
  const fullURL = window.location.origin + window.location.pathname;

  const activateGridViewButton = () => {
    addClass(ACTIVATE_GRID_CLASS, viewGridButton)
    removeClass(ACTIVATE_LIST_CLASS, viewListButton)
  }
  const activateListViewButton = () => {
    addClass(ACTIVATE_LIST_CLASS, viewListButton)
    removeClass(ACTIVATE_GRID_CLASS, viewGridButton)
  }

  if (viewGridButton) {
    on('click', activateGridViewButton, viewGridButton)
  }
  if (viewListButton) {
    on('click', activateListViewButton, viewListButton)
  }

  if (fullURL == currentURL) {
    if (viewGridButton) {
      on('click', () => {
        window.location = '?view=grid'
      }, viewGridButton)
    }
    if (viewListButton) {
      on('click', () => {
        window.location = '?view=list'
      }, viewListButton)
    }
  } else {
    if (viewGridButton) {
      on('click', () => {
        if (window.location.href.indexOf('view=list') > -1) {
          window.location = currentURL.replace('view=list', 'view=grid')
        } else {
          window.location = currentURL + '&view=grid'
        }
      }, viewGridButton)
    }
    if (viewListButton) {
      on('click', () => {
        if (window.location.href.indexOf('view=grid') > -1) {
          window.location = currentURL.replace('view=grid', 'view=list')
        } else {
          window.location = currentURL + '&view=list'
        }
      }, viewListButton)
    }
  }

  if (window.location.href.indexOf('view=list') > -1) {
    addClass(ACTIVATE_LIST_CLASS, viewListButton)
    removeClass(ACTIVATE_GRID_CLASS, viewGridButton)
  }
}

